import { hexaServiceAPI } from '../../../apis'
import { IResponseService } from './service-interface'

export enum ESearchLevel {
  STATE = 'state',
  MUNICIPALITY = 'municipality',
  NEIGHBORHOOD = 'neighborhood',
  BLOCK = 'block',
  PROPERTY = 'property'
}

export interface IResponseEngineMetrics {
  message: string
  data: Data
}

export interface Data {
  capital_gain: CapitalGain
}

export interface CapitalGain {
  featureName: string
  featureVersion?: string
  lastYearCapitalGain?: number
  timeSeries?: TimeSeries
}

export interface TimeSeries {
  [key: string]: number
}

export const getCapitalGainMetrics = async (
  latitude: number,
  longitude: number
): Promise<IResponseService<IResponseEngineMetrics>> => {
  try {
    const response = await hexaServiceAPI.get<IResponseEngineMetrics>(
      `/data-engine-metrics?latitude=${latitude}&longitude=${longitude}&query=plusvalia`
    )
    return {
      isSuccess: true,
      data: response
    }
  } catch (error) {
    return {
      isSuccess: false,
      error
    }
  }
}

export interface LookupAddressBody {
  level?: ESearchLevel
  location: {
    latitude: number
    longitude: number
  }
}

export interface LookAddressResponse {
  message: string
  data: LookAddressData
}

export interface LookAddressData {
  id: string
  centroid: number[]
}

export const lookupAddress = async ({
  level = ESearchLevel.BLOCK,
  location
}: LookupAddressBody): Promise<IResponseService<LookAddressData>> => {
  try {
    const response = await hexaServiceAPI.get<LookAddressResponse>(
      `lookup?level=${level}&latitude=${location.latitude}&longitude=${location.longitude}`
    )
    return {
      isSuccess: true,
      data: response?.data
    }
  } catch (error) {
    return {
      isSuccess: false,
      error
    }
  }
}

export interface MetricsResponse {
  price: Price
  rent: Rent
  caprate: Caprate
  walkability: Walkability
  traffic: Traffic
}

export interface Price {
  avg: number
  avgSqm: number
  belowLevel: BelowLevel
}

export interface BelowLevel {
  maxIndex: number
  minIndex: number
  maxAvg: number
  minAvg: number
  maxAvgSqm: number
  minAvgSqm: number
}

export interface Rent {
  avg: number
  avgSqm: number
  belowLevel: BelowLevel2
}

export interface BelowLevel2 {
  maxIndex: number
  minIndex: number
  maxAvg: number
  minAvg: number
  maxAvgSqm: number
  minAvgSqm: number
}

export interface Caprate {
  index: number
  belowLevel: BelowLevel3
}

export interface BelowLevel3 {
  max: number
  min: number
}

export interface Walkability {
  level: string
  scale: number
}

export interface Traffic {
  level: string
  scale: number
  perHours: PerHour[]
}

export interface PerHour {
  hour: number
  trafficScale: number
}

interface MetricsBody {
  id: string
  level?: ESearchLevel
}
export const getMetrics = async ({
  id,
  level = ESearchLevel.BLOCK
}: MetricsBody): Promise<IResponseService<MetricsResponse>> => {
  try {
    const response = await hexaServiceAPI.get<MetricsResponse>(
      `/metrics/${level}/${id}`
    )
    return {
      isSuccess: true,
      data: response
    }
  } catch (error) {
    return {
      isSuccess: false,
      error
    }
  }
}
